[
  {
    "country": "SV",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "SV",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "UY",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "UY",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },

  {
    "country": "HN",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "HN",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "EC",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "EC",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "PE",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "PE",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "PY",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "PY",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "CR",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "CR",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "CL",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "CL",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "AR",
    "ambiente": "PRD",
    "roles": "ADMIN"
  },
  {
    "country": "AR",
    "ambiente": "UAT",
    "roles": "VIEWER"
  },
  {
    "country": "AR",
    "ambiente": "NPE",
    "roles": "VIEWER"
  },
  {
    "country": "RD",
    "ambiente": "NPE",
    "roles": "ADMIN"
  },
  {
    "country": "RD",
    "ambiente": "UAT",
    "roles": "ADMIN"
  },
  {
    "country": "RD",
    "ambiente": "NPE",
    "roles": "ADMIN"
  }
]
